import { type PropsWithChildren, useState } from "react";

import { AnimatePresence, motion } from "framer-motion";

import { renderChevronAnimation } from "@shared/selects/utils";

export interface AccordionProps {
  title: string;
  isExpandedByDefault?: boolean;
  testId?: string;
}

export function Accordion({
  title,
  isExpandedByDefault,
  testId,
  children,
}: PropsWithChildren<AccordionProps>) {
  const [isExpanded, setExpanded] = useState(isExpandedByDefault || false);

  return (
    <div className="border-b border-gray-100 mx-8" data-testid={testId}>
      <h4
        className="text-base font-semibold m-0 flex items-center pt-5 pb-5 cursor-pointer"
        onClick={() => setExpanded(!isExpanded)}
      >
        <span className="flex-1">{title}</span>
        {renderChevronAnimation(isExpanded)}
      </h4>
      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ ease: "easeOut", duration: 0.2 }}
            className="overflow-hidden px-[2rem] mx-[-2rem]"
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
